interface DeliveryType {
  value: string;
  label: string;
}

export const deliveryTypes: DeliveryType[] = [
  { value: 'dellin', label: 'Деловые Линии' },
  { value: 'major', label: 'Major' },
  { value: 'ems', label: 'EMS' },
  { value: 'flippost', label: 'Flip Post' },
];

export const deliveryTypes2: DeliveryType[] = [
  ...deliveryTypes,
  { value: 'self-delivery', label: 'Самовывоз' },
  { value: 'unspecified', label: 'Не указано' },
  { value: 'other', label: 'Информация скоро будет' },
];

export const payerTypes: DeliveryType[] = [
  { value: 'recipient', label: 'Получатель' },
  { value: 'sender', label: 'Отправитель' },
];

export const selfDeliveryTypes: DeliveryType[] = [
  { value: 'courier', label: 'Курьер' },
  { value: 'confidant', label: 'Доверенное лицо' },
];

export const selfDeliveryTypesOrderInfo: DeliveryType[] = [
  { value: 'courier', label: 'курьером' },
  { value: 'confidant', label: 'доверенным лицом' },
];

export const recipientTypes: DeliveryType[] = [
  { value: 'customer', label: 'Заказчик' },
  { value: 'third party', label: 'Третья сторона' },
];
